/**
 * @generated SignedSource<<c2e5d3daf1e63f870ba3eb00b9faf5fa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RelatedPapersFragment$data = {
  readonly relatedPapers: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PaperCardFragment">;
  }>;
  readonly " $fragmentType": "RelatedPapersFragment";
};
export type RelatedPapersFragment$key = {
  readonly " $data"?: RelatedPapersFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RelatedPapersFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RelatedPapersFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 6
        }
      ],
      "concreteType": "Paper",
      "kind": "LinkedField",
      "name": "relatedPapers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaperCardFragment"
        }
      ],
      "storageKey": "relatedPapers(limit:6)"
    }
  ],
  "type": "Paper",
  "abstractKey": null
};

(node as any).hash = "8697fa0281bb76d6fcf0f4d9392340be";

export default node;
